module.exports = __webpack_public_path__ + "static/work19-b95deb039e0b7f2ffcbd0a3f8bab8ebf.jpg";